export default "/images/logo-light.svg?96c274dae02dae215c95d0a7ef202e3a";